import styled from "styled-components";
import "@fontsource/righteous";

export const Container = styled.div`
  display: "flex";
  flex-direction: "column";
  background-color: red;
`;
